/**
 * El rol «número que se compara» del compositor: mono tabular, definido UNA vez
 * y consumido por nombre (regla del sistema visual v2, igual que
 * `src/features/partners/numero.ts`).
 *
 * Son dos números y los dos se leen en vertical: el peso de cada archivo de la
 * bandeja, uno debajo del otro, y el cronómetro de la grabación, que cambia
 * cada 200 ms y en proporcional saltaría de ancho en cada dígito.
 */
export const NUM_MONO_MICRO = 'font-mono text-micro tabular-nums';
